import React, {createRef} from "react";
import FJBarIcon from "../../../icon/bar.svg";
import FJBarArrowIcon from "../../../icon/wedgit-arrow-right.svg";
import FJLocalStore from '../../../store/FJLocalStore'
import classNames from 'classnames'
import Style from './FJResourceExpand.module.less'
import InlineSVG from 'react-inlinesvg'

function FJResourceExpand(props) {
  const {isExpand} = props;
  const {onClick} = props;
  const containerRef = createRef();
  const value = isExpand ? FJLocalStore._("hide") : FJLocalStore._("unhide");
  return (
    <div ref={containerRef}
         className={classNames(Style.expand, 'u-tooltip-right')}
         tooltip={value}
         data-original-title={value}
         onClick={onClick}
    >
      <InlineSVG src={FJBarIcon}/>
      <InlineSVG src={FJBarArrowIcon}
                 className={classNames(Style.arrow, {[Style.active]: isExpand})}/>
    </div>
  );
}

export default FJResourceExpand;
